import { CellContext } from '@tanstack/react-table';

import { cn } from 'support/helpers/cn/cn';
import { useValue } from 'components/WebEDI/helpers';

import { overflowTooltipTarget } from '../../../components/OverflowTooltip/overflowTooltipTarget';
import { CellProps } from '../../types';
import { useCellClassNames } from '../cellHelpers';
import { ViewWrapperCell } from './ViewWrapperCell';

export type Props<TData, TValue> = CellContext<TData, TValue> &
  Pick<CellProps, 'fieldId' | 'isHighlighted' | 'diffStatus' | 'originalValue' | 'wasAIEdited'>;
export const ViewURLCell = <TData = unknown, TValue = string>({
  row,
  cell,
  column,
  table,
  isHighlighted,
  fieldId,
  diffStatus,
  originalValue,
  wasAIEdited,
}: Props<TData, TValue>) => {
  const value = useValue(row.original, fieldId, column.columnDef.meta?.optionalConfig?.expression);
  const {
    columnDef: { meta: columnMeta },
  } = column;
  const cellClassNames = useCellClassNames({
    row,
    table,
    isFirstColumn: column.getIsFirstColumn(),
    isLastColumn: column.getIsLastColumn(),
  });

  return (
    <ViewWrapperCell
      className={cellClassNames}
      isHighlighted={isHighlighted}
      fieldId={fieldId}
      meta={columnMeta}
      cell={cell}
      diffStatus={diffStatus}
      originalValue={originalValue}
      textAlign={columnMeta?.optionalConfig?.textAlign}
      wasAIEdited={wasAIEdited}
    >
      <span className="flex w-full min-w-0 items-center">
        <div className={cn('flex w-full min-w-0 gap-x-0.5 overflow-hidden')}>
          <span {...overflowTooltipTarget} className="truncate">
            <a href={value} target="_blank" rel="noreferrer" className="underline">
              {value}
            </a>
          </span>
        </div>
      </span>
    </ViewWrapperCell>
  );
};
